<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import Modal from 'components/Modal.vue';
import ProductComparisonService from 'services/ProductComparisonService';
import AdvancedComparisonsForProduct from 'components/competitor-app-v2/advanced-comparisons/AdvancedComparisonsForProduct.vue';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
});

const store = useStore();
const token = computed(() => store.getters['user/token']);
const activeIndustries = computed(() => store.getters.activeIndustries);

const comparisons = computed(() => props.product.advancedComparisons);
const hasComparisons = computed(() => comparisons.value?.length > 0);

const comparisonsDetails = ref(null);

const selectionModalVisible = ref(false);

async function showComparisons() {
  if (!hasComparisons.value) {
    return;
  }

  comparisonsDetails.value = await ProductComparisonService.getAdvancedComparisonsForProduct(
    props.product.uid,
    activeIndustries.value,
    token.value,
  );

  selectionModalVisible.value = true;
}

const productWithAdvancedComparisonDetails = computed(() => ({
  ...props.product,
  advancedComparisons: comparisonsDetails.value,
}));
</script>

<template>
  <div v-if="hasComparisons">
    <button
      class="ce-btn-as-link"
      @click.prevent.stop="showComparisons()">
      <fa-icon icon="right-left" />
    </button>

    <modal
      v-if="selectionModalVisible"
      class="ce-advancedComparisonProductResultModal"
      :headline="$t('competitorApp.v2.advancedComparisons.productResult.modal.headline')"
      closable
      @close="selectionModalVisible = false">
      <div class="ce-modalContent">
        <AdvancedComparisonsForProduct
          v-if="comparisonsDetails"
          :product="productWithAdvancedComparisonDetails"
          show-industry />
      </div>
    </modal>
  </div>
</template>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-modal.ce-advancedComparisonProductResultModal .ce-modalInner {
  .ce-modalContent {
    padding: @space-4;
  }
}
</style>
